import { WorkspaceProvider, useOptionalWorkspace } from "../context/WorkspaceContext";

// AUTO-CRM-32: the Stage sidebar (src/stage/StageSidebar.jsx) replaces the old
// top header, and AppRoutes provides the workspace for the whole app. AppShell
// only adds a provider when a page is rendered on its own (tests, embeds).
export default function AppShell({ children }) {
  const workspace = useOptionalWorkspace();
  if (workspace) return children;
  return <WorkspaceProvider>{children}</WorkspaceProvider>;
}
